<template>
  <div class="tabbar_wrap" :style="{
    // '--tabbarBG': verConfig.tabbar.background || '#fff',
    // '--pageBG': verConfig.pagesBG || '#f5f5f5',
  }">
    <div class="page_placeholder">
      <router-view />
    </div>
    <keep-alive>
      <!-- :style="{ '--color': verConfig.tabbar.color || '#000' }" -->
      <Tabbar v-model="active" :active-color="'var(--tarbarActiveColor)' || verConfig.theme"
        inactive-color="var(--tarbarColor)" route fixed placeholder safe-area-inset-bottom :before-change="handleClick">
        <TabbarItem v-for="(item, index) in verConfig.tabbar.pages" :key="index" :name="index"
          :to="`/tabbar/${item.pagePath}`" :class="{ special: item.isSpecial }">
          <span>{{ $t(item.text) }}</span>
          <template #icon="props">
            <template v-if="index == 2">
              <div class="custom">
                <img :src="item.selectedIconPath" alt="">
                <span>{{ $t(('订金')) }}</span>
              </div>
            </template>
            <template v-else>
              <img v-if="verConfig.tabbar.type === 'image'" :src="props.active ? item.selectedIconPath : item.iconPath"
                alt="" />
              <i class="iconfont" v-else :class="{
                icon_active: props.active,
                [item.selectedIconPath]: props.active && item.selectedIconPath,
                [item.iconPath]: !props.active || !item.selectedIconPath
              }">
              </i>
            </template>
          </template>
        </TabbarItem>
      </Tabbar>
    </keep-alive>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from "vant";
export default {
  components: {
    Tabbar,
    TabbarItem,
  },
  data: () => ({
    // active: 0,
  }),
  created() { },
  methods: {
    handleClick(event) {
      this.$cookie.remove('gameNum')
      if (event == 2) {
        this.$router.push('/new-recharge');
        return false
      }
      // if (event == 3) {
      //   this.$router.push('/inviteFriends');
      //   return false
      // }
      return true;
    },
    getIcon(item, active) {
      if (active) {
        return item.selectedIconPath || item.iconPath;
      }
      return item.iconPath;
    },
  },
  computed: {
    active: {
      get() {
        return this.$store.state.tabbar.active;
      },
      set(newVal) {
        return newVal;
      },
    },
  },
};
</script>

<style lang="less" scoped>
.tabbar_wrap {
  background: var(--tarbarBg);

  /deep/ .van-tabbar {
    max-width: 648px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    // filter: drop-shadow(0 0 4px #bbb);
    // background: var(--tabbarBG);
    background: var(--tarbarBg);

    &::after {
      border-top: 1px solid #ccc;
    }

    .van-tabbar-item--active {
      background: var(--tarbarBg);
    }

    img {
      height: 22px;
    }
  }
}

.page_placeholder {
  // padding-bottom: calc(50rem / 16);
}

.iconfont {
  font-size: calc(22rem / 16);
  // color: var(--color);
  color: var(--tarbarColor);
}

.icon_active {
  color: var(--tarbarActiveColor);
}

.special {
  margin-top: calc(-20rem / 16);
  border-radius: 50%;
  background: #fff;
  max-width: fit-content;
  padding: calc(6rem / 16);

  .iconfont {
    font-size: calc(50rem / 16);
  }
}

.custom {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: calc(60rem / 16);
  height: calc(60rem / 16);
  color: var(--light);
  background: linear-gradient(90deg,#bead6e,#99793a);
  border-radius: 50%;
  box-shadow: 0 2px 7px 0 #03031c73;
  margin-top: calc(-30rem / 16);
  position: relative;
  z-index: 1000;

  img {
    height: calc(22rem / 16);
    display: block;
  }

  span {
    font-size: calc(12rem / 16);
    margin-top: calc(4rem / 16);
    color: var(--light);
  }
}
</style>